/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { omit } from 'lodash';

const __vue_script__ = {
    name: 'ResourceCard',

    props: {
        event: {
            type: Object,
            required: true
        },

        info: {
            type: Object,
            required: true
        }
    },

    data() {
        let typeClass = 'location';
        if (this.info.is_agenda) {
            typeClass = 'agenda';
        } else if (this.info.is_person || this.info.is_prospect) {
            typeClass = 'person';
        }
        let prospectName;
        if (this.info.is_prospect) {
            // when we get prospect object from calendar appscript, it has same format as pax (fname, lname)
            // if we fetch prospect from /excerpt call to backend, it has label and not fname or lname
            prospectName = this.info.origin.label || this.$utils.pax.getFullName(this.info.origin);
        }
        return {
            title: this.info.title,
            is_agenda: false,
            is_person: false,
            is_prospect: false,
            typeClass,
            prospectName,
            ...omit(this.info, ['depth', 'fixed', 'isParent'])
        };
    },

    methods: {
        /**
         * Returns the location href for the agenda.
         * @returns {string} The sessions href.
         */
        getAgendaLink() {
            const agendaModule = this.$services.blueprint.getModuleByName('sessions');
            return this.$utils.modules.getRouteHref(agendaModule, 'list', { eventId: this.event._id, ...this.origin });
        },

        /**
         * Returns the location href for the current meeting.
         * @returns {string} The location href.
         */
        getLocationLink() {
            const meetingModule = this.$services.blueprint.getModuleByName('meetings');
            return this.$utils.modules.getRouteHref(meetingModule, 'view-location', { eventId: this.event._id, ...this.origin });
        },

        /**
         * Returns the person href.
         * @returns {string} The person href.
         */
        getPersonLink() {
            const paxModule = this.$services.blueprint.getModuleByName('participants');
            return this.$utils.modules.getRouteHref(paxModule, 'view', { eventId: this.event._id, ...this.origin });
        },

        /**
         * Returns the prospect href.
         * @returns {string} The prospect href.
         */
        getProspectLink() {
            const meetingsModule = this.$services.blueprint.getModuleByName('meetings');
            return this.$utils.modules.getRouteHref(meetingsModule, 'externals-view', { eventId: this.event._id, ...this.origin });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resource",class:_vm.typeClass},[(_vm.is_agenda)?[_c('a',{attrs:{"href":_vm.getAgendaLink()}},[_vm._v(_vm._s(_vm.title))])]:(_vm.is_person)?[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":_vm.$utils.assets.getPaxPicture(_vm.event._id, _vm.origin._id),"onerror":"this.className = 'hidden'","onload":"this.className = ''","alt":"Avatar"}}),_c('span',[_vm._v(_vm._s(_vm.$utils.pax.getInitial(_vm.origin)))])]),_c('a',{attrs:{"href":_vm.getPersonLink()}},[_vm._v(_vm._s(_vm.$utils.pax.getFullName(_vm.origin)))])]:(_vm.is_prospect)?[_c('div',{staticClass:"avatar"},[_c('span',[_vm._v(_vm._s(_vm.prospectName.charAt(0)))])]),_c('a',{attrs:{"href":_vm.getProspectLink()}},[_vm._v(_vm._s(_vm.prospectName))])]:[_c('i',{staticClass:"ic-door"}),_c('a',{attrs:{"href":_vm.getLocationLink()}},[_vm._v(_vm._s(_vm.title))])]],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ResourceCard.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__